export default __webpack_public_path__ + "static/media/Dash Me 1.b3676c26.svg";